<script>
import InputGroup from "@/components/_Shared/InputGroup";
import { mapActions } from "vuex";

export default {
  components: {
    InputGroup
  },

  data() {
    return {
      donieCovered: false,
      email: "",
      password: "",
      passwordConfirm: "",
      preloader: false,
      error: "",
      reseted: false
    };
  },

  methods: {
    ...mapActions("user", ["sendPasswordReset"]),

    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          let data = {
            email: this.email,
            password: this.password,
            password_confirmation: this.passwordConfirm,
            token: this.$route.params.token
          };

          await this.sendPasswordReset(data);
          this.reseted = true;
        }
      } catch (e) {
        this.error = e;
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <div class="container-center">
    <div v-if="!donieCovered" class="donie">
      <img src="../../static/donie.svg" alt="Donie">
    </div>
    <div v-else class="donie-covered">
      <img src="../../static/donie-blindfolded.svg" alt="Donie olhos fechados">
    </div>

    <div class="box text-center text-purple">
      <div class="logo">
        <img src="../../static/logo.svg" alt="Donamaid">
      </div>

      <transition name="fade" mode="out-in">
        <div v-if="reseted" class="success-message">
          <img src="../../static/icon-success.svg" class="mb-20" height="70px">
          <b class="text-purple mb-5">SENHA REDEFINIDA!</b>
          <small>A sua senha foi redefinida com sucesso!</small>
          <router-link :to="{name:'login'}" class="btn bg-purple mt-10">ir para o login</router-link>
        </div>
        <div v-else @keyup.enter="submit">
          <b>Redefina sua senha</b>

          <div class="form-group text-left">
            <input-group
              :error="errors.first('digite seu email')"
              v-validate.disabled="'required|email'"
              label="digite seu e-mail"
              type="email"
              v-model="email"
              customClasses="with-icon icon-user"
            />

            <input-group
              :error="errors.first('digite sua nova senha')"
              label="digite sua nova senha"
              type="password"
              ref="password"
              v-model="password"
              v-validate="'required|min:8'"
              customClasses="with-icon icon-password"
              @focus="donieCovered = true"
              @blur="donieCovered = false"
            />

            <input-group
              :error="errors.first('confirme sua nova senha')"
              label="confirme sua nova senha"
              type="password"
              v-model="passwordConfirm"
              v-validate="'required|min:8|confirmed:password'"
              customClasses="with-icon icon-password"
              @focus="donieCovered = true"
              @blur="donieCovered = false"
            />
          </div>

          <transition name="zoom" mode="out-in">
            <div v-if="error" class="badge error mt-20">{{error}}</div>
          </transition>

          <div class="text-center mt-20">
            <div class="btn-group">
              <div
                class="btn bg-purple mt-20"
                :class="{'btn--loading': preloader}"
                @click="submit"
                tabindex="-1"
              >
                <span>redefinir</span>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.success-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.container-center {
  position: absolute;
  background: #ededed;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.box {
  width: 440px;
  margin-top: -25px;
  padding: 50px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.donie,
.donie-covered {
  width: 440px;
  height: 200px;
  display: inherit;
  margin-top: 20px;
  z-index: 99;
}

.donie img,
.donie-covered img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.logo {
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;
  height: 60px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.icon-user {
  background: url("../../static/user.png") no-repeat 10px 10px;
  background-size: 20px;
}

.icon-password {
  background: url("../../static/lock.png") no-repeat 10px 10px;
  background-size: 20px;
}

@media (max-width: 768px) {
  .box {
    width: 340px;
  }
  .donie,
  .donie-covered {
    width: 440px;
  }
}

@media (max-width: 480px) {
  .box {
    width: 200px;
    margin-top: -25px;
  }
  .donie,
  .donie-covered {
    width: 300px;
  }
  .logo {
    margin-top: 0;
    margin-bottom: 20px;
  }
}

@media (max-width: 320px) {
  .box {
    width: 190px;
    margin-top: -43px;
    padding: 30px;
  }
  .donie,
  .donie-covered {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ResetYouPassword.vue